import { render, staticRenderFns } from "./ItemDetailSublet.vue?vue&type=template&id=f178fa9e&scoped=true"
import script from "./ItemDetailSublet.vue?vue&type=script&lang=js"
export * from "./ItemDetailSublet.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailSublet.vue?vue&type=style&index=0&id=f178fa9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f178fa9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f178fa9e')) {
      api.createRecord('f178fa9e', component.options)
    } else {
      api.reload('f178fa9e', component.options)
    }
    module.hot.accept("./ItemDetailSublet.vue?vue&type=template&id=f178fa9e&scoped=true", function () {
      api.rerender('f178fa9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemDetailSublet.vue"
export default component.exports